<template>

<div class="footer">
    <div class="fc">
    <div class="lj">
        <div class="item">
            <span class="x">服务热线</span>
            <span class="d"><a href="tel:021-60665499">021-60665499</a></span>
        </div>

        <div class="tu_set">
            <div class="it">
                <img src="https://oss.mifengbangzu.com/web/gfgzh.jpg">
                <div>官方公众号</div>
            </div>
           <div class="it">
                <img src="https://oss.mifengbangzu.com/web/fyxt2.jpg">
                <div>圆租系统</div>
            </div>
            <div class="it">
                <img src="https://oss.mifengbangzu.com/web/ajxt2.jpg">
                <div>销售系统</div>
            </div>
  
            
        </div>
    </div>


    </div>
    <div class="icp">
版权为运长集团所有     2022     沪ICP备11009004号-1
    </div>
</div>

</template>
<script>
  export default {
  	name: "MobileHeader",
    data() {
        return {
        };
    },
  }
</script>
<style lang="scss" scoped>

.footer{
    background-color:#11934e;
    height: 5rem;
    .icp{
        height: 0.80rem;
        border-top: solid #fff 0.01rem;
        text-align: center;
        line-height: 0.8rem;
        font-size: 0.16rem;
    }
    width: 100%;
    color:#fff;
    .fc{
        width: 6rem;
        height: 4.2rem;
        margin-left: auto;
        margin-right: auto;
        .contact{
            padding-top: 0.2rem;
            color: #fff;
            font-size: 0.18rem;  
            padding-bottom:0.2rem;
            .d{
                margin-left: 0.05rem;
                font-size: 0.25rem;  
                
            }
            .xx{margin-left: 0.8rem;}
        }
    }
    .lj{
        text-align: center;
        padding-top: 0.3rem;
        font-size: 0.16rem;
        .item{
            font-size: 0.2rem;
            div{
                margin-top: 0.1rem;
                &:first-child{
                      margin-top: unset;
                }
            }
            .d{ font-size: 0.35rem;  a{color: #fff !important;}  }
        }
        .tu_set{
             margin-top: 0.3rem;
            display: flex;
            .it{
                margin-right: 0.1rem;
                    img{
                        width: 2rem;
                        height: 2rem;
                    }
                    div{
                        margin-top: 0.1rem;
                        text-align:center;
                    }

            }
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/layouts/MobileFooter/index.vue